import { StatusTone } from '../Modules/Shared/Types/status-tone.type';

export enum RefundReason {
  DUPLICATE = 'duplicate',
  FRAUDULENT = 'fraudulent',
  REQUESTED_BY_CUSTOMER = 'requested_by_customer',
  OTHER = 'other',
}

export const REFUND_REASON_OPTIONS: readonly RefundReason[] = [
  RefundReason.DUPLICATE,
  RefundReason.FRAUDULENT,
  RefundReason.REQUESTED_BY_CUSTOMER,
  RefundReason.OTHER,
];

export const REFUND_REASON_LABEL: Readonly<Record<string, string>> = {
  [RefundReason.DUPLICATE]: 'backoffice.enums.refund_reason.duplicate',
  [RefundReason.FRAUDULENT]: 'backoffice.enums.refund_reason.fraudulent',
  [RefundReason.REQUESTED_BY_CUSTOMER]: 'backoffice.enums.refund_reason.requested_by_customer',
  [RefundReason.OTHER]: 'backoffice.enums.refund_reason.other',
};

export const REFUND_STATUS_LABEL: Readonly<Record<string, string>> = {
  pending: 'backoffice.enums.refund_status.pending',
  requires_action: 'backoffice.enums.refund_status.requires_action',
  succeeded: 'backoffice.enums.refund_status.succeeded',
  failed: 'backoffice.enums.refund_status.failed',
  canceled: 'backoffice.enums.refund_status.canceled',
};

export const REFUND_STATUS_TONE: Readonly<Record<string, StatusTone>> = {
  pending: 'warning',
  requires_action: 'warning',
  succeeded: 'positive',
  failed: 'danger',
  canceled: 'neutral',
};

export enum CreditNoteReason {
  DUPLICATE = 'duplicate',
  FRAUDULENT = 'fraudulent',
  ORDER_CHANGE = 'order_change',
  PRODUCT_UNSATISFACTORY = 'product_unsatisfactory',
}

export const CREDIT_NOTE_REASON_OPTIONS: readonly CreditNoteReason[] = [
  CreditNoteReason.DUPLICATE,
  CreditNoteReason.FRAUDULENT,
  CreditNoteReason.ORDER_CHANGE,
  CreditNoteReason.PRODUCT_UNSATISFACTORY,
];

export const CREDIT_NOTE_REASON_LABEL: Readonly<Record<string, string>> = {
  [CreditNoteReason.DUPLICATE]: 'backoffice.enums.credit_note_reason.duplicate',
  [CreditNoteReason.FRAUDULENT]: 'backoffice.enums.credit_note_reason.fraudulent',
  [CreditNoteReason.ORDER_CHANGE]: 'backoffice.enums.credit_note_reason.order_change',
  [CreditNoteReason.PRODUCT_UNSATISFACTORY]: 'backoffice.enums.credit_note_reason.product_unsatisfactory',
};

export const CREDIT_NOTE_STATUS_LABEL: Readonly<Record<string, string>> = {
  issued: 'backoffice.enums.credit_note_status.issued',
  void: 'backoffice.enums.credit_note_status.void',
};

export const CREDIT_NOTE_STATUS_TONE: Readonly<Record<string, StatusTone>> = {
  issued: 'positive',
  void: 'neutral',
};
